export const companyInfo={
    alert_hour: "18",
    finish_hour: "0",
    in_warehouse_time: "18",
    name: "tamata_operation",
    out_warehouse_time: "37",
    shift_hour: "9",
    start_hour: "9"
}